import { FC } from 'react';
import { MessageComposerTypeOwnProps } from './interfaces';
import { Text } from '@/components/Typography';

export const VoiceMessageComposer: FC<MessageComposerTypeOwnProps<Blob[]>> = ({
  submitting,
  onSubmit,
  onSwitchType,
}) => {
  const handleSendPlaceholder = () => {
    onSubmit([]);
  };

  return (
    <div className="flex w-full flex-col gap-3">
      <div className="flex items-center justify-between">
        <Text variant="text-md-regular" className="text-white/80">
          Voice capture is coming soon.
        </Text>
        <button
          type="button"
          className="text-sm font-medium text-white underline hover:no-underline"
          onClick={onSwitchType}
        >
          Use text composer
        </button>
      </div>
      <button
        type="button"
        className="rounded-lg bg-white/10 px-4 py-2 text-sm font-medium text-white transition hover:bg-white/20 disabled:cursor-not-allowed disabled:opacity-60"
        onClick={handleSendPlaceholder}
        disabled={submitting}
      >
        Send placeholder voice note
      </button>
    </div>
  );
};
